module.exports = __webpack_public_path__ + "static/media/nyc-citi-bike.7a12741d.jpg";